import axiosRetry, { isNetworkOrIdempotentRequestError } from "axios-retry";

import _axios from "axios";
import { store } from "@/store/store";
import { MUTATION_UPDATE } from "@/store/mutations";
import {formatDuration, guid, srt2webvtt} from '@/common/utils';

const axios = _axios.create({
  timeout: 20000,
  headers: {
    "Content-Type": "application/json"
  }
});

axiosRetry(axios, {
  shouldResetTimeout: true,
  retryCondition: error => {
    if (error.response.data.type === 'wwwsite\\exceptions\\PlayerNoRightsException'){
      return false;
    }
    return (
      isNetworkOrIdempotentRequestError(error) || error.code === "ECONNABORTED"
    );
  },
  retryDelay: retryCount => {
    return retryCount * 1000;
  }
});

/**
 *
 * @param i
 * @param params
 * @returns {Promise<any>}
 */
export async function getData(i, params) {
  let BASE_URL = process.env.VUE_APP_BASE_URL;
  if (!BASE_URL) {
    BASE_URL = "https://" + window.location.host + "/player/";
  }

  try {
    console.log(BASE_URL + i,params);
    let response = await axios.get(BASE_URL + i, {
      params
    });

    return response.data;
  } catch (e) {
    console.error(e.message);
    if (e.response && e.response.data.type === "wwwsite\\exceptions\\PlayerNoRightsException") {
      store.commit(MUTATION_UPDATE, ["error", "Unauthorized"]);
      store.commit(MUTATION_UPDATE, ["errorLogo", e.response.data.logo]);
      store.commit(MUTATION_UPDATE, ["errorLoginUrl", e.response.data.loginUrl]);
    }else if (e.response && e.response.status === 401) {
      //rights error
      store.commit(MUTATION_UPDATE, ["error", "Unauthorized"]);
      throw new Error("Request failed ,please try again.");
    } else {
      store.commit(MUTATION_UPDATE, ["error", "Player loading failed."]);
      throw new Error("Request failed ,please try again.");
    }
  }
}
export function reportEngagement(eid,start, end) {
  if (!store.state.setting.engagementStatsBaseUrl) {
    return;
  }

  if (end - start < 3) {
    return;
  }

  let _guid = guid();
  let url = store.state.setting.engagementStatsBaseUrl + `&s=${start}&e=${end}&v=${_guid}&eid=${eid}`;
  if (typeof navigator.sendBeacon !== "undefined") {
    navigator.sendBeacon(url + "&beacon=1");
  } else {
    axios.get(url, {});
  }
}


export async function getTranscript(url) {
  try {
    let response = await axios.get(url);

    let vttText;
    if(response.data.startsWith("WEBVTT")){
      vttText = response.data
      vttText = vttText.replace(/<v\s+([^>]+)>(?=\S)/g, '$1: ');
    }else{
      vttText = srt2webvtt(response.data);
    }
    let vttBlob = new Blob([vttText], {type : 'text/vtt'});
    return URL.createObjectURL(vttBlob);
  } catch (e) {
    //ignore exception
  }

  return null;

}

export async function getChapters(url) {
  try {
    let response = await axios.get(url);
    if(typeof response.data.chapters !== 'object'){
      return [];
    }

    return response.data.chapters;
  } catch (e) {
    //ignore exception
  }

  return null;

}
